import { useDayJsCountdown } from '@pkg/hooks';
export function useFormattedMsToTime(
    expiration: string,
    onExpired?: (expired?: boolean) => void,
    useLongFormat = false,
) {
    const { days, hours, minutes, seconds } = useDayJsCountdown(expiration, onExpired);
    const timeUnits = {
        day: days > 0 ? days : 0,
        hour: hours > 0 ? hours : 0,
        minute: minutes > 0 ? minutes.toString().padStart(2, '0') : '00',
        second: seconds > 0 ? seconds.toString().padStart(2, '0') : '00',
    };

    const unitsWithLabel = Object.keys(timeUnits).map((unit) => {
        const value = timeUnits[unit];
        const label = unit.toString();
        const shortFormat = label?.charAt(0);
        const stringValue = !useLongFormat ? `${value}${shortFormat}` : `${value} ${value > 1 ? `${label}s` : label}`;
        return (timeUnits[unit] = value ? stringValue : '');
    });

    return unitsWithLabel.some((unit) => unit?.length) ? unitsWithLabel.join(' ').trim() : undefined;
}
